import { FETCH_MONTHLY_ACTIVE_USERS, LOAD_MONTHLY_ACTIVE_USERS } from '../Actions/MonthlyActiveUsers'

const initialState = {
  unregisteredCount: 0,
  inactiveCount: 0,
  activeCount: 0,
  account: '',
  month: 0,
  year: 0
}

/**
  * monthlyActiveUserReducer
  * @desc Action handler for Overview part of the redux state
  * @param {Object} state
  * @param {action} action
  * @return {Object} state updated redux state
*/
export default function monthlyActiveUserReducer (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }
  switch (action.type) {
    case FETCH_MONTHLY_ACTIVE_USERS:
      return Object.assign({}, state, { loading: true })
    case LOAD_MONTHLY_ACTIVE_USERS:
      return Object.assign({}, { ...action.data.getMonthlyActiveUsers, loading: false })
    default:
      return state
  }
}
